import './empty-state.scss';

import PlusIcon from '@/media/icons/plus.svg?react';
import Button from '@/shared/ui/button';

interface IProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: React.ReactNode;
  className?: string;
}

const EmptyState: React.FC<IProps> = ({
  title,
  description,
  icon,
  actionLabel,
  onAction,
  actionIcon = <PlusIcon className="empty-state__button-icon" />,
  className
}) => {
  const hasAction = Boolean(actionLabel);

  return (
    <div className={className ? `empty-state ${className}` : 'empty-state'}>
      {icon && (
        <div className="empty-state__icon-wrap" aria-hidden="true">
          {icon}
        </div>
      )}

      <h2 className="empty-state__title">{title}</h2>

      <p className="empty-state__description">{description}</p>

      {hasAction && (
        <div className="empty-state__actions">
          <Button
            type="button"
            variant="filled-purple"
            size="big"
            onClick={onAction}
          >
            {actionIcon}
            {actionLabel}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
